// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1o4PJ"};